import { render, staticRenderFns } from "./AssetCenter.vue?vue&type=template&id=6b5fad2a&scoped=true"
import script from "./AssetCenter.vue?vue&type=script&lang=js"
export * from "./AssetCenter.vue?vue&type=script&lang=js"
import style0 from "./AssetCenter.vue?vue&type=style&index=0&id=6b5fad2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5fad2a",
  null
  
)

export default component.exports